import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCompanyStore } from 'stores';
//helpers
import { capitalize } from 'helpers';
import { isCompanyLanguage, normalizeLanguageCode } from 'utils/apiLanguage';
import { buildLocalizedPathname, getLocaleFromPathname } from 'utils/localePath';

const LanguageSwitcher = ({ className = '', dataTestId = 'language switcher' }) => {
  const { i18n } = useTranslation(['header']);
  const { languages } = useCompanyStore();
  const navigate = useNavigate();
  const location = useLocation();
  const [language, setLanguage] = useState(() => normalizeLanguageCode(i18n.language) || 'es');

  const changeLang = async (lang) => {
    const normalized = normalizeLanguageCode(lang);
    setLanguage(normalized);
    localStorage.setItem('i18nextLng', normalized);

    const newPath = buildLocalizedPathname(
      location.pathname,
      normalized,
      location.search,
      location.hash,
    );
    const currentPath = `${location.pathname}${location.search}${location.hash}`;

    if (newPath !== currentPath) {
      navigate(newPath, { replace: true });
    }
  };

  useEffect(() => {
    const current = getLocaleFromPathname(location.pathname);

    if (isCompanyLanguage(current, languages)) {
      setLanguage(current);
    }
  }, [location.pathname, languages]);

  return (
    <Form.Group controlId="FormDepartment" className={className}>
      <Form.Select
        size="sm"
        onChange={(e) => changeLang(e.target.value)}
        as="select"
        value={language}
        data-testid={dataTestId}
      >
        {languages.map((lan) => (
          <option key={lan.nombre} value={lan.code_iso2}>
            {capitalize(lan.nombre)}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
};

export default LanguageSwitcher;
